module.exports = __webpack_public_path__ + "static/media/logo-isotipo.98b6e486.png";